// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Hover from "../../primitives/Hover.res.js";
import * as React from "react";
import * as Button from "../actions/Button.res.js";
import * as Inline from "../layout-and-structure/Inline.res.js";
import * as Popover from "../overlays/Popover.res.js";
import * as Tooltip from "../overlays/Tooltip.res.js";
import * as Touchable from "../../primitives/Touchable.res.js";
import * as ReactAria from "react-aria";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as ReactUpdateEffect from "../../primitives/ReactUpdateEffect.res.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as OverlayTriggerView from "../overlays/OverlayTriggerView.res.js";
import * as ReactUpdateDebounced from "../../primitives/ReactUpdateDebounced.res.js";
import * as InputOptionalNumberField from "./InputOptionalNumberField.res.js";

function SelectNumberRangeFilter(props) {
  let onChange = props.onChange;
  let value = props.value;
  let disabledTooltip = props.disabledTooltip;
  let __disabled = props.disabled;
  let formatValue = props.formatValue;
  let __precision = props.precision;
  let precision = __precision !== undefined ? __precision : 3;
  let disabled = __disabled !== undefined ? __disabled : false;
  let match = Popover.useTrigger(undefined, undefined, undefined);
  let popoverTriggerRef = match.ref;
  let popoverAriaProps = match.ariaProps;
  let popover = match.state;
  let match$1 = Hover.use(popoverTriggerRef, undefined, undefined);
  let match$2 = React.useState(() => false);
  let setFocused = match$2[1];
  let props$1 = {
    onFocusWithinChange: focused => setFocused(param => focused)
  };
  let match$3 = ReactAria.useFocusWithin(props$1);
  let match$4 = React.useState(() => value);
  let setRange = match$4[1];
  let range = match$4[0];
  let debouncedValue = ReactUpdateDebounced.use(range, 1000);
  ReactUpdateEffect.use1(() => {
    onChange(debouncedValue);
  }, [debouncedValue]);
  React.useEffect(() => {
    if (value !== range) {
      setRange(param => value);
    }
  }, [value]);
  let handleMinChange = value => setRange(range => {
    let next;
    if (range !== undefined) {
      let newrecord = {...range};
      next = (newrecord.min = value, newrecord);
    } else {
      next = {
        min: value
      };
    }
    if (next !== undefined && next.min === undefined && next.max === undefined) {
      return;
    } else {
      return next;
    }
  });
  let handleMaxChange = value => setRange(range => {
    let next;
    if (range !== undefined) {
      let newrecord = {...range};
      next = (newrecord.max = value, newrecord);
    } else {
      next = {
        max: value
      };
    }
    if (next !== undefined && next.min === undefined && next.max === undefined) {
      return;
    } else {
      return next;
    }
  });
  let handleReset = param => {
    setRange(param => {});
    popover.close();
  };
  let formattedRange;
  if (range !== undefined) {
    let min = range.min;
    if (min !== undefined) {
      let max = range.max;
      formattedRange = max !== undefined ? formatValue(min) + ` — ` + formatValue(max) : `≥ ` + formatValue(min);
    } else {
      let max$1 = range.max;
      formattedRange = max$1 !== undefined ? `≤ ` + formatValue(max$1) : I18n.t("All");
    }
  } else {
    formattedRange = I18n.t("All");
  }
  let rangeMinValue = Stdlib_Option.flatMap(range, param => param.min);
  let rangeMaxValue = Stdlib_Option.flatMap(range, param => param.max);
  let newrecord = {...match$3.focusWithinProps};
  return JsxRuntime.jsxs("div", (newrecord.style = {
    marginRight: "1px"
  }, newrecord.children = [
    JsxRuntime.jsx(Tooltip.make, {
      children: JsxRuntime.jsx(Touchable.make, {
        children: JsxRuntime.jsx(OverlayTriggerView.make, {
          children: JsxRuntime.jsx("span", {
            children: formattedRange
          }),
          preset: "filter",
          size: "compact",
          label: props.label,
          hovered: match$1[1],
          active: popover.isOpen,
          focused: match$2[0],
          highlighted: Stdlib_Option.isSome(range),
          disabled: disabled
        }),
        ariaProps: popoverAriaProps.triggerProps,
        disabled: disabled,
        ref: popoverTriggerRef
      }),
      placement: "top",
      content: JsxRuntime.jsx(Tooltip.Span.make, {
        text: Stdlib_Option.getOr(disabledTooltip, "")
      }),
      disabled: !disabled || Stdlib_Option.isNone(disabledTooltip),
      delay: 350
    }),
    popover.isOpen ? JsxRuntime.jsx(Popover.make, {
        children: JsxRuntime.jsx(Popover.Dialog.make, {
          children: JsxRuntime.jsxs(Box.make, {
            children: [
              JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx(InputOptionalNumberField.make, {
                    value: rangeMinValue,
                    maxValue: rangeMaxValue,
                    precision: precision,
                    label: I18n.t("Minimum"),
                    placeholder: "-∞",
                    onChange: handleMinChange
                  }),
                  JsxRuntime.jsx(InputOptionalNumberField.make, {
                    value: rangeMaxValue,
                    minValue: rangeMinValue,
                    precision: precision,
                    label: I18n.t("Maximum"),
                    placeholder: "∞",
                    onChange: handleMaxChange
                  })
                ],
                style: {
                  display: "flex",
                  width: "180px",
                  columnGap: "12px"
                }
              }),
              JsxRuntime.jsx(Box.make, {
                spaceBottom: "normal"
              }),
              JsxRuntime.jsx(Inline.make, {
                children: JsxRuntime.jsx(Button.make, {
                  label: I18n.t("Reset"),
                  variant: "subtle",
                  size: "small",
                  icon: "cross",
                  onPress: handleReset
                }),
                align: "end"
              })
            ],
            spaceX: "large",
            spaceTop: "xlarge",
            spaceBottom: "medium"
          }),
          ariaProps: popoverAriaProps.overlayProps
        }),
        triggerRef: popoverTriggerRef,
        state: popover,
        placement: "bottom start",
        shouldUpdatePosition: false,
        modal: false
      }) : null
  ], newrecord));
}

let make = SelectNumberRangeFilter;

export {
  make,
}
/* Box Not a pure module */
